import { identity } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useFilterValueText } from '../../../../utils/helpers/filters'
import DateFilter from '../../../../components/filter/DateFilter'
import FilterLink from '../../../../components/filter/FilterLink'
import FilterSideModal from '../../../../components/filter/FilterSideModal'

const DatesFilter = ({ label, field, icon, full, presentation, recommendedOptions, ...props }) => {
  const { t } = useTranslation(['serviceOrders', 'common'])
  const [open, setOpen] = React.useState(false)

  const insertedAt = useFilterValueText('insertedAt')
  const scheduling = useFilterValueText('scheduling')
  const endDate = useFilterValueText('endDate')
  const slaExpiresAt = useFilterValueText('slaExpiresAt')
  const slaExpiredAt = useFilterValueText('slaExpiredAt')
  const selectedFilters = [insertedAt, scheduling, endDate, slaExpiresAt, slaExpiredAt].filter(identity)
  const filterCount = selectedFilters.length

  const displayLabel = label || t('serviceOrders:filters.dates')
  const datesLabel = t('common:dates', { count: filterCount })

  let selectedValue = filterCount > 1 && datesLabel
  if (!selectedValue) selectedValue = selectedFilters[0]

  return (
    <>
      <FilterLink
        icon={icon || 'RiCalendarEventFill'}
        label={displayLabel}
        value={selectedValue}
        onClick={() => setOpen(true)}
      />

      <FilterSideModal
        open={open}
        onClose={() => setOpen(false)}
        label={displayLabel}
        renderOptions={() => (
          <>
            <DateFilter
              label={t('common:opening')}
              field="insertedAt"
              presentation="list"
              isSelected={!!insertedAt}
              recommendedOptions={recommendedOptions}
            />
            <DateFilter
              label={t('common:schedulingDate')}
              field="scheduling"
              presentation="list"
              isSelected={!!scheduling}
              recommendedOptions={recommendedOptions}
            />
            <DateFilter
              label={t('common:completionDate')}
              field="endDate"
              presentation="list"
              isSelected={!!endDate}
              recommendedOptions={recommendedOptions}
            />
            <DateFilter
              label={t('common:sla')}
              field="slaExpiresAt"
              presentation="list"
              isSelected={!!slaExpiresAt}
              recommendedOptions={recommendedOptions}
            />
            <DateFilter
              label={t('common:overdue')}
              field="slaExpiredAt"
              presentation="list"
              isSelected={!!slaExpiredAt}
              recommendedOptions={recommendedOptions}
            />
          </>
        )}
      />
    </>
  )
}

export default DatesFilter
